import { render, staticRenderFns } from "./ModalNewMessageCriticism.vue?vue&type=template&id=66217b38"
import script from "./ModalNewMessageCriticism.vue?vue&type=script&lang=js"
export * from "./ModalNewMessageCriticism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports